<template>
    <div class="banner commer-content box-sizing">
        <div class="commer-list">
            <p class="commer-list-title">
				横幅管理>横幅列表
			</p>
            <div class="commer-list-seacch-box" style="margin-bottom: 40px;">
                <div class="left-search">
                    <el-input
                        placeholder="请输入关键字"
                        suffix-icon="el-icon-search"
                        v-model="getListParams.text" class="wordSearch" clearable>
                    </el-input>
                </div>
                <div class="right-add">
                    <el-button type="info" icon="el-icon-plus" @click='operation(1,"")'>新增</el-button>
                </div>
            </div>
            <div class="table-list">
				<el-table
					:data="tableData"
					border
					style="width: 100%">
					<el-table-column
						type="index"
						label="序号"
						width="70">
					</el-table-column>
                    <el-table-column
                        prop="name"
                        label="名称">
                    </el-table-column>
                    <el-table-column
                        prop="imgUrl"
                        label="图片地址">
                    </el-table-column>
                    <!-- <el-table-column
                    prop="status"
                    label=" 图片"  width='100'>
                    <template slot-scope="scope">
                        <img :src="scope.row.imgUrl?scope.row.imgUrl:''">
                    </template>
                    </el-table-column> -->
                    <el-table-column
                        prop="createDate"
                        label="创建时间">
                        <template slot-scope="scope">
                            <span>{{$moment(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="releaseDate"
                        label="发布时间">
                        <template slot-scope="scope">
                            <span>{{$moment(scope.row.releaseDate).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="220">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click='operation(2,scope.row.id)'>编辑</el-button>
                            <el-button type="text" size="small"  @click='ifDelete(scope.row.id)'>删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pages">
				<el-pagination
					@current-change="getList()"
					:current-page="getListParams.pageNo"
					:page-size="getListParams.pageSize"
					layout="total, prev, pager, next, jumper"
					:total="totals">
				 </el-pagination>
		   </div>
        </div>
        <el-dialog
		:title="titleMsg"
		:visible.sync="ifAdd"
		:modal-append-to-body='false'
		width='50%'>
            <el-main>
                <el-form :model="addParams" ref="addParams" label-width="100px" class="demo-ruleForm" :rules="rules">
                    <div style="display:flex;margin-bottom:10px;">
                        <span class="LOGO">图片</span>
                        <photo-upload :imgList='addParams.imgUrl' @uploadImg='uploadImg'></photo-upload>
                    </div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="名称" prop="name">
                                <el-input v-model="addParams.name" placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-main>
            <span slot="footer" class="dialog-footer">
				<el-button @click="ifAdd = false">取 消</el-button>
				<el-button type="primary" @click="save('addParams')"> 保 存</el-button>
			</span>
            
        </el-dialog>
    </div>
</template>
<script>
import PhotoUpload from  '@/components/public/photoUpload.vue' 
export default {
    data(){
        return{
            addParams:{
                imgUrl:'',
                name:''
            },
            rules:{

            },
            titleMsg:'新增',
            ifAdd:false,
            totals:0,
             getListParams:{
                pageNo:1,
                pageSize:10,
                text:''
            },
            tableData:[]
        }
    },
    mounted(){
        this.getList()
    },
    methods:{
        //出现新增框
        operation:function(operationStatus,companyID){
            var vm=this;
            this.operationStatus=operationStatus
            this.ifAdd=true
            this.$nextTick(()=>{
                this.$refs['addParams'].resetFields();
            }) 
            if(operationStatus==1){
                vm.$common.deletesObj(vm.addParams,'id')
                vm.addParams.imgUrl=''
                vm.titleMsg='新增'
            }else{
                vm.titleMsg='编辑'
                vm.$http.get('/api/console/banner/query',{
                    params:{
                            id:companyID
                        },
                })
                .then(function(response){
                     vm.addParams=response.data
                    // for(var i in resTemp){
                    //     if(i=='updateDate'||i=='createDate'){
                    //         delete resTemp[i]
                    //     }
                    // }
                    // vm.addParams=resTemp
                })
                
            
            }
        },
        //获取列表
        getList(type){
            var vm=this;
            vm.getListParams.pageNo=type?type:1
            vm.$http.get('api/console/banner/queryPage',
                {params:vm.getListParams}
            )
            .then(function(response){
                vm.tableData=response.data&&response.data.items?response.data.items:[]
                vm.totals=parseInt(response.data.page.rowCount)*1
            })
        },
        //新增编辑数据
        save:function(formName){
            
            var vm=this;
            vm.$refs[formName].validate((valid) => {
                if (valid) {
                    vm.$http.post('/api/console/banner/save',vm.addParams)
                    .then(function(response){
                        if(response.code==0){
                            vm.$common.Alerts.call(vm,"保存成功",2)
                            vm.ifAdd=false;
                            vm.getList(vm.getListParams.pageNo)
                        }
                    })
                }
            })

            
        },
        uploadImg(val){
            this.$set(this.addParams,"imgUrl",val)
        },
        ifDelete:function(companyID){
            var vm=this;
            // this.ifDeleteBox=true
            this.$common.Delets.call(this,(action, instance, done)=>{
                if (action === 'confirm') {
                    vm.$http.post('/api/console/banner/delete',{id:companyID})
                    .then(function(response){
                        if(response.code==0){
                            done()
                            vm.$common.Alerts.call(vm,"删除成功",2)
                            // vm.ifDeleteBox=false
                            vm.getList()
                        }
                            
                    })
                }else{
                    done()
                }
            })
        },
    },
    components:{
        PhotoUpload,
    }
}
</script>

<style lang="less">
.banner{
    .LOGO{
        width: 100px;
        text-align: right;
        line-height: 60px;
        margin-right: 20px;
    }
    .el-select{
        width: 100%;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/banner/banner.vue